<template>
  <div id="app" class="app">
    <div v-if="getGlobalLoader" class="global-loader">
      <va-progress-circle indeterminate />
    </div>
    <notifications />
    <router-view />
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "App",
  data() {
    return {
      // Temporary config for 2.1.
      contextConfig: {
        gradient: false,
        shadow: "sm", // 3 states: 'sm', 'lg', undefined (no shadow).
        invertedColor: true,
      },
    };
  },
  computed: {
    getGlobalLoader() {
      return this.$store.state.app.loader;
    },
  },
  provide() {
    return {
      contextConfig: this.contextConfig,
    };
  },
  watch: {
    // Temporary colors fix for 2.1.
    "contextConfig.invertedColor"(val) {
      const invertedColorClass = "va-inverted-color";
      if (val) {
        document.body.classList.add(invertedColorClass);
      } else {
        document.body.classList.remove(invertedColorClass);
      }
    },
  },
  created() {
    this.getCurrentUser();
  },
  methods: {
    ...mapActions("auth", ["getCurrentUser"]),
  },
};
</script>

<style lang="scss">
@import "../sass/main.scss";
body {
  height: 100%;

  #app {
    height: 100%;
  }
}
.global-loader {
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(51, 51, 51, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 99999;
}
</style>
